import CameraScan from './CameraScan.js'

export default CameraScan
